import useSWR from "swr";
import { BESC } from "config/chains";
import { CONFIG_UPDATE_INTERVAL } from "lib/timeConstants";
import { fetchUserStats } from "lib/indexer/client";

export default function useUniqueUsers() {
  const { data } = useSWR(
    "uniqueUsers",
    async () => {
      try {
        const res = await fetchUserStats();
        return {
          [BESC]: res.totalUsers,
          total: res.totalUsers,
        };
      } catch {
        return { [BESC]: 0, total: 0 };
      }
    },
    { refreshInterval: CONFIG_UPDATE_INTERVAL }
  );

  return data;
}
